import { Navigate, useLocation } from "react-router-dom"
import { useAuthStore } from "@/stores/auth-store"

interface PlatformAdminRouteProps {
  children: React.ReactNode
}

const STEP_UP_WINDOW_MS = 30 * 60 * 1000

export function PlatformAdminRoute({ children }: PlatformAdminRouteProps) {
  const location = useLocation()
  const { isPlatformAdmin, aal } = useAuthStore()

  if (!isPlatformAdmin) {
    return <Navigate to="/app" replace />
  }

  // Step-up: require a fresh AAL2 grant (≤ 30 min) before entering the
  // admin panel. The sessionStorage timestamp is a UX hint; backend
  // requireFreshAal2 is the source of truth for actual mutations.
  if (aal !== 'aal2') {
    const returnTo = location.pathname + location.search
    return <Navigate to={`/mfa-challenge?stepUp=1&returnTo=${encodeURIComponent(returnTo)}`} replace />
  }

  if (typeof window !== 'undefined') {
    const lastAal2At = Number(sessionStorage.getItem('bc.mfa.lastAal2At') ?? '0')
    if (!Number.isFinite(lastAal2At) || Date.now() - lastAal2At > STEP_UP_WINDOW_MS) {
      const returnTo = location.pathname + location.search
      return <Navigate to={`/mfa-challenge?stepUp=1&returnTo=${encodeURIComponent(returnTo)}`} replace />
    }
  }

  return <>{children}</>
}
